import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { authModel } from '../models/auth';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule]
})

export class LoginComponent implements OnInit {
    public loginForm!: UntypedFormGroup;
    public loading = false;
    public submitted = false;
    public loginTypes: any;
    public error = '';
    public respone: authModel | null = null;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private authenticationService: AuthenticationService,
        private cdr: ChangeDetectorRef
    ) {
        if (this.authenticationService.checkLoginState()) {
            this.router.navigate(['/home']);
        }
    }

    public ngOnInit() {
        this.loginTypes = environment.level

        // Migrate old 'monitoring' value to 'statistieken'
        let screenType = localStorage.getItem('ScreenType');
        if (screenType === 'monitoring') {
            screenType = 'statistieken';
            localStorage.setItem('ScreenType', 'statistieken');
        }

        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            remember_me: [true],
            login_type: [''],
            screen_type: [screenType || 'statistieken', Validators.required]
        });
        this.loginForm.controls['login_type'].setValue(environment.level[0], { onlySelf: true });
        this.loginForm.controls['remember_me'].setValue(true); // Always remember by default
    }

    public get f() { return this.loginForm.controls; }

    public onSubmit() {
        this.submitted = true;

        if (this.loginForm.invalid) {
            console.log('Form is invalid:', this.loginForm.errors);
            return;
        }

        this.loading = true;

        const deviceToken = this.authenticationService.generateDeviceToken(255);
        this.authenticationService.login(this.f['username'].value, this.f['password'].value, this.f['remember_me'].value, deviceToken, this.f['login_type'].value).subscribe({
            next: (data) => {
                if (data.one_time_password === true) {
                    localStorage.setItem('tempPassword', 'true');
                    this.router.navigateByUrl('/change_password')
                } else {
                    this.authenticationService.getAuthUserInformation().subscribe({
                        next: (data) => {
                            if (data.Company.id !== undefined && data.Employee.id !== undefined) {
                                if (this.f['remember_me'].value) {
                                    this.authenticationService.requestApiKey(deviceToken).subscribe({
                                        next: (data) => {
                                            this.loading = false;
                                            const screenType = localStorage.getItem('ScreenType');
                                            const targetRoute = screenType || '/statistieken';
                                            console.log('Navigating to:', targetRoute);
                                            this.router.navigateByUrl(targetRoute);
                                        },
                                        error: () => {
                                            this.error = 'Kon API-sleutel niet verkrijgen';
                                            this.loading = false;
                                            this.cdr.detectChanges();
                                        }
                                    });
                                } else {
                                    this.loading = false;
                                    const screenType = localStorage.getItem('ScreenType');
                                    const targetRoute = screenType || '/statistieken';
                                    console.log('Navigating to:', targetRoute);
                                    this.router.navigateByUrl(targetRoute);
                                }
                            }
                        },
                        error: () => {
                            this.error = 'Kon gebruikersinformatie niet ophalen';
                            this.loading = false;
                            this.cdr.detectChanges();
                        }
                    });
                }
            },
            error: (error) => {
                // Handle different error structures
                if (error.error) {
                    if (typeof error.error === 'string') {
                        this.error = error.error;
                    } else if (error.error.detail) {
                        this.error = error.error.detail;
                    } else if (error.error.title) {
                        this.error = error.error.title;
                    } else if (error.error.message) {
                        this.error = error.error.message;
                    } else {
                        this.error = 'Login mislukt - onbekende fout';
                    }
                } else if (error.message) {
                    this.error = error.message;
                } else {
                    this.error = 'Login mislukt';
                }
                this.loading = false;
                this.cdr.detectChanges(); // Trigger change detection
            }
        });
    }

    public setScreenType() {
        localStorage.setItem('ScreenType', this.loginForm.controls['screen_type'].value);
    }
}
